import React from "react";
import View from "../../assets/img/eye.svg";
import Sound from "../../assets/img/sound.svg";
import Calendar from "../../assets/img/calendar-color.svg";
import StatusCheck from "../../assets/img/status-check.svg";
import Question from "../../assets/img/question-mark.svg";
import Ellipse from "../../assets/img/ellipse-1.svg";

import { Col, Row } from "react-bootstrap";
import { handleTextToSpeech, handleimageUrl } from "../../utils/ApiFunctions";
import { useNavigate } from "react-router-dom";
import { useLocalization } from "../Localization/Localization";

export const Type1 = ({ questiondata, callback, questions }) => {
  const navigate = useNavigate();
  const { t } = useLocalization();
  return (
    <div>
      <div className="ques-type type-1">
        <h3>
          <i>
            <img
              src={Sound}
              onClick={() => handleTextToSpeech(questiondata?.title)}
            />
          </i>{" "}
          {questiondata?.title}
        </h3>

        <Row>
          <Col md={12}>
            {questiondata?.type == "voiceOnly" ? (
              <div className="audio-plyer">
                {/* <ReactAudioPlayer
                  src={handleimageUrl(questiondata?.mediaUrl)}
                  autoPlay
                  controls
                /> */}

                <audio controlsList="nodownload" controls>
                  <source
                    src={handleimageUrl(questiondata?.mediaFile)}
                    controls
                  />
                </audio>
              </div>
            ) : questiondata?.type == "videoWithQuestion" ? (
              <Col md={12}>
                <div className="q-video">
                  <iframe
                    src={handleimageUrl(questiondata?.mediaFile)}
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen
                  ></iframe>
                </div>
              </Col>
            ) : questiondata?.type == "photoWithQuestion" ? (
              <div className="question-image">
                <img src={handleimageUrl(questiondata?.mediaFile)} />
              </div>
            ) : (
              ""
            )}
          </Col>
        </Row>
        <Row>
          {questiondata?.options?.map((val, i) => (
            <Col md={6} key={i}>
              <div className="question-option">
                <input
                  type="checkbox"
                  disabled
                  checked={
                    questiondata?.subType == "mulipleansweroption"
                      ? questiondata?.mulipleansweroption?.includes(
                          `option${i}`
                        )
                      : `option${i}` == questiondata?.answerOption
                  }
                />
                <span></span>
                <h5>{val}</h5>
                <div className="sound-spekr">
                  <p
                    onClick={() => {
                      handleTextToSpeech(val);
                    }}
                  >
                    <img src={Sound} />
                  </p>
                </div>
              </div>
            </Col>
          ))}

          <Col md={12} className="text-end mt-5">
            <button className="btn-btn-primary" onClick={callback}>
              {" "}
              {t("next")}
            </button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Type1;
